import { mock } from '@npco/utils-apollo-testing-link'

import { HasActiveAccountOrTransactionsQuery } from '../HasActiveAccountOrTransactionsQuery.generated'

export const HasActiveAccountOrTransactionsQueryMocks = mock(
  HasActiveAccountOrTransactionsQuery
)
